import { useI18n } from "@expertloop/i18n/react";
import { getLocaleDisplayName } from "@expertloop/i18n";
import type { PickedTranslation } from "./translations";

/** Mention sous un texte : traduit de quelle langue, déjà dans la langue visée, ou pas encore traduit. */
export function TranslationNote({ picked }: { picked: PickedTranslation }) {
	const { t } = useI18n();
	if (picked.kind === "original") return null;

	const name = (locale: string | null) => (locale ? getLocaleDisplayName(locale, "en") : t("adminChatDetail.translation.unknownLanguage"));
	const label =
		picked.kind === "translated"
			? t("adminChatDetail.translation.translatedFrom", { language: name(picked.sourceLocale) })
			: picked.kind === "same_language"
				? t("adminChatDetail.translation.alreadyIn", { language: name(picked.locale) })
				: t("adminChatDetail.translation.notTranslated");

	return <span className="translation-note">{label}</span>;
}
